import superagent from 'superagent'
import { getServerUrl } from 'redux/configuration/selectors'
import { getGroupPosition, getMediaPosition } from 'redux/navigation/selectors'
import { isMediaInfoFeatureEnable } from 'redux/configuration/selectors'

export const INIT_MEDIA_INFO = 'INIT_MEDIA_INFO'
export function initMediaInfo(media) {
    return function initMediaInfo(dispatch, getState) {
        if(! isMediaInfoFeatureEnable(getState()))
        {
            return;
        }

        dispatch(fetchMediaInfo(media))
    }
}

export function fetchMediaInfo(media) {
    return async function fetchMediaInfo(dispatch, getState) {

        const { arkName, uuid } = media

        if(arkName === undefined) return

        const url = `${getServerUrl(getState())}/visualizer/api/record/${arkName}/media/${uuid}`
        const res = await superagent.get(url)

        dispatch(loadMediaInfo(res.body, getGroupPosition(getState()), getMediaPosition(getState())))
    }
}

export const LOAD_MEDIA_INFO = 'LOAD_MEDIA_INFO'
export const loadMediaInfo = (mediaInfo, groupPosition, mediaPosition) => ({
    type: LOAD_MEDIA_INFO,
    mediaInfo,
    groupPosition,
    mediaPosition,
})
